import { PATH_TOP_SPENDER } from "@configs";
import { IGetLeaderboard } from "@interfaces";
import { selectMerchant } from "@redux";
import { useNotify } from "@utils";
import { Skeleton } from "antd";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { leaderboardAPI } from "src/API/leaderboard";
import { topCharoenAPI } from "src/API/topCharoen";
import styled from "styled-components";
import { ArrowLeftColor } from "../icon";
import { TopSpenderModal } from "./Modal";

interface IProps {
    userInfo: any;
}

export const ComponentTopSpender = (props: IProps) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const { userInfo } = props;
    const { error } = useNotify();
    const history = useHistory();
    const orgID = useSelector(selectMerchant)._id;
    const merchant = useSelector(selectMerchant);
    const [showButton, setShowButton] = useState<boolean>(true);
    const { id } = useParams<{ id: string }>();
    const [leaderboard, settLeaderboard] = useState<IGetLeaderboard>();
    const [isLoading, setIsloading] = useState(true);
    const { themes } = useSelector(selectMerchant);
    const redirectToListRef = useRef(false);

    const pushToLeaderboardList = () => {
        if (!id || redirectToListRef.current) return;
        redirectToListRef.current = true;
        history.push(PATH_TOP_SPENDER + "/list/" + id);
    };

    const handleModal = () => {
        setShowModal(!showModal);
        if (!leaderboard?.isActive) {
            history.push("/");
        }
    };

    const checkUser = async () => {
        try {
            const check = await topCharoenAPI.getMyRangeTopSpender({
                organization_id: orgID,
                profile_id: userInfo._id,
                sale_date_from: "2023-01-15",
                sale_date_to: "2023-10-15",
            });
            if (check.data.error === "0") {
                setShowButton(false);
            }
        } catch (err: any) {
            error(err.message);
        }
    };
    // STAR-1133-HOTFIX-REVERT: revert this block before merging STAR-1105 dedup branch
    const getLeaderboard = async () => {
        if (!id) {
            setIsloading(false);
            return;
        }

        try {
            const get = await leaderboardAPI.getleaderboard(id);
            const currentLeaderboard = get.data;
            if (!currentLeaderboard) {
                setIsloading(false);
                return;
            }

            if (!currentLeaderboard.isActive) {
                settLeaderboard(currentLeaderboard);
                setShowModal(true);
                setIsloading(false);
                return;
            }

            const joinedFromUserInfo =
                Array.isArray(userInfo?.contact?.leaderboardJoin) &&
                userInfo.contact.leaderboardJoin.includes(id);
            let joinedFromApi = false;

            if (!joinedFromUserInfo && userInfo?._id) {
                const getJoin = await leaderboardAPI.getleaderboardOwn(`${id}/${userInfo._id}`);
                joinedFromApi = Array.isArray(getJoin.data) && getJoin.data.length > 0;
            }

            if (currentLeaderboard.till && new Date(currentLeaderboard.till) <= new Date()) {
                if (joinedFromUserInfo || joinedFromApi) {
                    pushToLeaderboardList();
                    return;
                }
                settLeaderboard(currentLeaderboard);
                setIsloading(false);
                return;
            }

            if (joinedFromUserInfo || joinedFromApi) {
                pushToLeaderboardList();
                return;
            }

            settLeaderboard(currentLeaderboard);
            setIsloading(false);
        } catch (err: any) {
            error(err.message);
            setIsloading(false);
        }
    };
    // STAR-1133-HOTFIX-REVERT: end

    useEffect(() => {
        // checkUser();
        redirectToListRef.current = false;
        getLeaderboard();
    }, [id, userInfo?._id]);

    return (
        <>
            <StyledContainer
                color={leaderboard?.color ? leaderboard?.color : "#000"}
                themeColor={themes?.themeColor!}
            >
                <div className="wholePage">
                    <div className="backgroundImage">
                        <Skeleton loading={isLoading} active avatar title={false} paragraph={false}>
                            <img
                                src={leaderboard?.coverImage[0] ? leaderboard?.coverImage[0] : ""}
                                alt="Leaderboard"
                            />

                            <div className="backIcon" onClick={() => history.push("/")}>
                                <ArrowLeftColor color={themes?.themeColor} />
                                {/* <span>{t("page.back")}</span> */}
                            </div>
                            <div className="whiteGradiant"></div>
                        </Skeleton>
                    </div>
                    <div className="content">
                        <Skeleton
                            loading={isLoading}
                            active
                            title={false}
                            paragraph={{ rows: 2, width: [120, 120] }}
                        >
                            <h1>{leaderboard?.name ? leaderboard?.name : "Top Spenders"}</h1>
                            <p>
                                {leaderboard?.detail ? leaderboard?.detail : "ลุ้นรับบัตร Fan Meet"}
                            </p>
                        </Skeleton>

                        <div className="buttonsColumn">
                            <Skeleton
                                loading={isLoading}
                                active
                                title={false}
                                paragraph={{ rows: 2, width: [120, 120] }}
                            >
                                {!userInfo?.contact?.leaderboardJoin?.includes(
                                    leaderboard?._id
                                ) && (
                                    <button className="blue" onClick={handleModal}>
                                        เข้าร่วมแคมเปญ
                                    </button>
                                )}
                                <button onClick={pushToLeaderboardList}>
                                    Top Spenders
                                </button>
                            </Skeleton>
                        </div>
                    </div>
                    <TopSpenderModal
                        handleModal={handleModal}
                        showModal={showModal}
                        userInfo={userInfo}
                        themeColor={leaderboard?.color ? leaderboard?.color : "#0573cd"}
                        leaderboardId={id}
                        confirmationImage={
                            leaderboard?.confirmationImage[0]
                                ? leaderboard?.confirmationImage[0]
                                : ""
                        }
                        isActive={leaderboard?.isActive}
                    />
                </div>
            </StyledContainer>
        </>
    );
};
const StyledContainer = styled.div<{ color: string; themeColor: string }>`
    height: 100dvh;
    .backgroundImage {
        .ant-skeleton {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
            border-radius: 10px;
            padding: 12px;
            .ant-skeleton-avatar {
                width: 312px;
                height: 512px;
                margin-bottom: 12px;
                margin-top: 12px;
                border-radius: 16px;
            }
            .ant-skeleton-header {
                padding-right: 0;
            }
            .ant-skeleton-title {
                width: 268px;
                margin: 0 auto;
                height: 10px;
                border-radius: 16px;
                margin-bottom: 8px;
            }
            .ant-skeleton-paragraph {
                text-align: center;
                width: 100%;
                display: table;
                margin: 0 auto;
                margin-bottom: 12px;
                li {
                    margin: 0 auto;
                    margin-top: 5px;
                    border-radius: 16px;
                    height: 10px;
                    &:last-child {
                        margin-top: 18px;
                    }
                }
            }
        }
        .backIcon {
            position: absolute;
            top: 20px;
            left: 20px;
            cursor: pointer;
            z-index: 1;
            display: flex;
            align-items: center;
            span {
                margin-left: 10px;
                color: ${(p) => p.themeColor};
            }
        }
        img {
            width: 100%;
        }
    }
    .whiteGradiant {
        background: radial-gradient(
            100% 72% at 50% 5%,
            rgba(255, 255, 255, 0) 70%,
            rgba(255, 255, 255, 0.62) 92%,
            #fff 100%
        );
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        z-index: 0;
    }
    .content {
        position: relative;
        z-index: 1;
        margin: -3.5rem auto 16px auto;
        .ant-skeleton {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 20px;
            border-radius: 10px;
            padding: 12px;
            .ant-skeleton-avatar {
                width: 312px;
                height: 312px;
                margin-bottom: 12px;
                margin-top: 12px;
                border-radius: 16px;
            }
            .ant-skeleton-header {
                padding-right: 0;
            }
            .ant-skeleton-title {
                width: 268px;
                margin: 0 auto;
                height: 10px;
                border-radius: 16px;
                margin-bottom: 8px;
            }
            .ant-skeleton-paragraph {
                text-align: center;
                width: 100%;
                display: table;
                margin: 0 auto;
                margin-bottom: 12px;
                li {
                    margin: 0 auto;
                    margin-top: 5px;
                    border-radius: 16px;
                    height: 10px;
                    &:last-child {
                        margin-top: 18px;
                    }
                }
            }
        }
        h1 {
            color: ${(p) => p.color || "#3293dc"};
            text-align: center;
            font-size: 42px;
            font-style: italic;
            font-weight: 800;
            line-height: inherit;
            margin-bottom: 12px;
        }
        p {
            color: #c4a363;
            text-align: center;
            font-size: 24px;
            font-style: italic;
            font-weight: 500;
            line-height: inherit;
        }
        .buttonsColumn {
            margin-top: 46px;
            display: flex;
            flex-direction: column;
            gap: 12px;
            padding: 0 30px;
            .ant-skeleton {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 20px;
                border-radius: 10px;
                padding: 12px;
                .ant-skeleton-paragraph {
                    text-align: center;
                    width: 100%;
                    display: table;
                    margin: 0 auto;
                    margin-bottom: 12px;
                    li {
                        margin: 0 auto;
                        margin-top: 5px;
                        border-radius: 16px;
                        height: 20px;
                        &:last-child {
                            margin-top: 18px;
                        }
                    }
                }
            }
            button {
                border-radius: 14px;
                border: 1px solid ${(p) => p.color || "#0573cd"};
                background: #fff;
                color: ${(p) => p.color || "#0573cd"};
                text-align: center;
                font-size: 13px;
                font-style: normal;
                font-weight: 700;
                line-height: inherit;
                padding: 14.5px 0;
                cursor: pointer;
            }
            .blue {
                border-radius: 14px;
                background: ${(p) => p.color || "#0573cd"};
                color: #fff;
            }
        }
    }
`;
